<template>
    <div>
        <!-- <van-nav-bar title="" left-text="back" left-arrow @click-left="onClickLeft" /> -->
        <div id="app">
            <div class="list-box">
                <div class="title">Fill in information</div>
                <div>
                    <div class="font-16 left-text">product name</div>
                    <van-cell-group> <van-field v-model="form.name" :border="true" /></van-cell-group>
                </div>
                <div>
                    <div class="font-16 left-text">amount of money</div>
                    <van-cell-group> <van-field :border="true" v-model="form.amount" /></van-cell-group>
                </div>
            </div>
            <div class="fixed repay-box margin-top-30 ">
                <div class="theme-back repay" @click="submit()">
                    Generate Link
                </div>
            </div>
            <van-dialog v-model="show" title="" width="80%" cancel-button-text="close" confirm-button-text="copy"
                @confirm="confirm_copy" show-cancel-button>
                <div style="padding: 20px 20px 10px;    white-space: normal;word-break: break-all;overflow: hidden;">
                    <div> {{ url }}</div>
                </div>
            </van-dialog>

            <!-- <van-popup v-model="show" position="center" round :style="{ height: '30%' }">
                <van-datetime-picker v-model="currentDate" type="date" title="select" :min-date="minDate"
                    :max-date="maxDate" confirm-button-text="confirm" cancel-button-text="cancel" @cancel="show = false"
                    @confirm="confirm" />
            </van-popup> -->
        </div>
    </div>
</template>
  
<script>
export default {
    data() {
        return {
            form: {
                name: '',
                amount: '',
                id: ''
            },
            show: false,
            minDate: new Date('1900/1/1'),
            maxDate: new Date('2025/10/1'),
            currentDate: new Date(),
            url: ''
        }
    },
    created() {
        if (this.$route.query.id) {
            this.form.id = this.$route.query.id;
            this.getThirdOrderInfo();
        }
    },
    methods: {
        getThirdOrderInfo() {
            this.$http.post('/api/product/thirdOrderInfo', { id: this.form.id }).then((res) => {
                console.log(res.data.code)
                if (res.data.code == 0) {
                    this.form = res.data.data;
                } else {
                    this.$toast(res.data.msg)
                }
            })
        },
        onClickLeft() {
            this.$router.back()
        },
        confirm(value) {
            console.log(value)
            this.form.birthday = value.getFullYear() + "-" + (value.getMonth() + 1) + "-" + value.getDate()
            this.show = false
        },
        submit() {
            if (this.form.id) {
                this.payThirdOrder()
            } else {
                this.$http.post('/api/product/addThirdOrder', this.form).then((res) => {
                    console.log(res.data)
                    if (res.data.code == 0) {
                        this.url = window.location.href.split("/#")[0] + '/#/newrepayment?id=' + res.data.data.order_id;
                        this.show = true;
                    } else {
                        this.$toast(res.data.msg)
                    }
                })
            }

        },
        confirm_copy() {
            this.copyToClip(this.url)
        },
        payThirdOrder() {
            this.$http.post('/api/product/payThirdOrder', { orderId: this.form.id }).then((res) => {
                if (res.data.code == 0) {
                    this.copyToClip(res.data.data.url)
                } else {
                    this.$toast(res.data.msg)
                }
            })
        },
        copyToClip(content, message) {
            var aux = document.createElement("input");
            aux.setAttribute("value", content);
            document.body.appendChild(aux);
            aux.select();
            document.execCommand("copy");
            document.body.removeChild(aux);
            if (message == null) {
                this.$toast("Replicating Success");
            } else {
                this.$toast(message);
            }
        },
    }
}
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.van-cell {
    padding: 14px 0px;
}

#app {
    background: #F9F9F9;
    min-height: 100vh;
    padding: 12px 12px 30px 12px;
    box-sizing: border-box;


    .list-box {
        margin-bottom: 67px;
        background: #FFFFFF;
        box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.1);
        border-radius: 14px;
        padding: 13px 14px;
    }


    .title {
        font-size: 15px;
        color: #FFA06A;
        font-weight: 500;
        margin-bottom: 20px;
        margin-top: 20px;
    }

    .left-text {
        color: #101010;
    }

    .repay-box {
        bottom: 10px;
        margin: 0 auto;
        left: 0;
        right: 0;
        width: 299px;

        .repay {
            width: 80%;
            padding: 12px;
            font-size: 16px;
            color: #FFFFFF;
            font-weight: bold;
            border-radius: 24px;
            text-align: center;
        }
    }

}
</style>
  